import * as React from 'react';
import { getAdministrators } from '@/api/accounts';
import { useQuery } from '@tanstack/react-query';

import { useDialog } from '@/hooks/v2/use-dialog';
import { useUser } from '@/hooks/v2/use-user';

import { AdministratorsTable } from './components/administrators-table';

export function AccountAdministratorsPage(): React.JSX.Element {
  const dialog = useDialog();
  const { account } = useUser();
  if (!account) {
    return <div>No account found</div>;
  }
  const { data, isLoading, refetch } = useQuery({
    queryKey: ['administrators', account?.id],
    queryFn: async () => await getAdministrators(account?.id),
  });

  const handleOnSuccess = React.useCallback(async () => {
    await refetch();

    dialog.handleClose();
  }, [dialog, refetch]);

  const users = data?.administrators;

  return <AdministratorsTable loading={isLoading} onCreated={handleOnSuccess} rows={users ?? []} />;
}
